import { getToken } from 'firebase/messaging';
import { initFCMClient } from './init-fcm-client';

export const getFCMToken = async (): Promise<string> => {
  const client = await initFCMClient();
  const token = await getToken(client);

  return token;
};
